import { render, staticRenderFns } from "./retention.vue?vue&type=template&id=2d7131ad&"
import script from "./retention.vue?vue&type=script&lang=js&"
export * from "./retention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports